<template>
  <div>
    <ul class="f-list flex">
      <li v-for="(item, index) in list" :key="index" class="center">
        <div class="tx-center">
          <img src="../../assets/img/device/tr-Smoke.jpg" alt="" />
          <div class="mt10">{{ item.name }}</div>
          <div class="c-b blod">{{ Number(item.value).toFixed(2) }}次</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { getsmoke } from "../../api/facility";
export default {
  data() {
    return {
      list: [],
      hide: false,
    };
  },
  props: ["cpNum"],
  created() {},
  mounted() {
    if (this.cpNum) this.getList();
  },
  watch: {
    cpNum() {
      this.getList();
    },
  },
  methods: {
    getList() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "fe559562bb2b456b848a545bb5d2eb4a" : this.cpNum;

      getsmoke({ c_company_num: cNum }).then((res) => {
        // console.log(res)
        if (res.wifismokewar.length) {
          this.list = res.wifismokewar;
        } else {
          this.$message.warning("该业务尚未开通，请联系管理员");
        }
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
